
import { Vue, Component, Prop } from "vue-property-decorator";
import moment from "moment";

import DateRangePicker from 'vue2-daterange-picker';
import UiButton from "@/components/button/ui-button.vue";
import FormInput from "@/components/form/FormInput.vue";

@Component({
  components: {
    DateRangePicker,
    FormInput,
    UiButton,
  },
})
export default class FormDateRangePicker extends Vue {
  @Prop({type: Object, default: null}) value!: any;

  maxDateValue: Date | null  = null;
  minDateValue: Date | null  = null;

  locale = {
    direction: 'ltr',
    format: 'dd-mm-yyyy',
    separator: ' - ',
  }

  handleToggle(state: boolean) {
    if (state == false) {
      this.maxDateValue = null;
      this.minDateValue = null;
    }
  }

  handleSelect() {
    this.maxDateValue = null;
    this.minDateValue = null;
  }

  handleUpdate(date: Date): void {
    this.$emit("input", date);
  }

  updateMaxDate(date: Date) {
    this.maxDateValue = moment(date).add(3, 'M').toDate();
    this.minDateValue = moment(date).subtract(3, 'M').toDate();
  }
}
